<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'特別営業日情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'特別営業日情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="addReservationFacilitySpecial()" [disabled]="!reservationFacilitySpecialFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="reservationFacilitySpecialFormGroup">
      <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'営業日種別' | translate}}</mat-label>
              <mat-select placeholder="{{'営業日種別' | translate}}" id="reservationSpecialDateType" formControlName="reservationSpecialDateType">
                <mat-option *ngFor="let reservationSpecialDateType of reservationSpecialDateTypes" [value]="reservationSpecialDateType">{{ reservationSpecialDateType | typeOfReservationSpecialDate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxLayout="row">
            {{'営業期間（※単日の場合は開始日のみ入力してください）' | translate}}
          </div>
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label>{{'開始日' | translate}}</mat-label>
              <input matInput [matDatepicker]="reservationSpecialStartDatePicker" placeholder="{{'特別営業開始' | translate}}" formControlName="reservationSpecialStartDate" readonly>
              <button mat-button matSuffix  aria-label="Clear" (click)="clearReservationSpecialStartDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(reservationSpecialStartDatePicker)"></mat-datepicker-toggle>
              <mat-datepicker #reservationSpecialStartDatePicker></mat-datepicker>
              <mat-error *ngIf="reservationSpecialStartDateControl.invalid">{{
                getErrorMessageToReservationSpecialStartDate() }}</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="50%">
              <mat-label>{{'終了日' | translate}}</mat-label>
              <input matInput [matDatepicker]="reservationSpecialEndDatePicker" placeholder="{{'特別営業終了日' | translate}}" formControlName="reservationSpecialEndDate" readonly>
              <button mat-button matSuffix  aria-label="Clear" (click)="clearReservationSpecialEndDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(reservationSpecialEndDatePicker)"></mat-datepicker-toggle>
              <mat-datepicker #reservationSpecialEndDatePicker></mat-datepicker>
              <mat-error *ngIf="reservationSpecialEndDateControl.hasError('before_start_date')">{{
                getErrorMessageToReservationSpecialEndDate() }}</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

          <div fxLayout="row"
            *ngIf="reservationSpecialDateTypeControl.value===RESERVATION_SPECIAL_DATE_TYPE_SPECIAL && reservationUnit===RESERVATION_UNIT_TIME"
            fxLayoutAlign="space-between end">
            <span>{{'時間枠' | translate}}</span>
            <button mat-stroked-button (click)="appendClick()">
              <mat-icon>add</mat-icon>
              <span>{{'時間枠追加' | translate}}</span>
            </button>
          </div>

          <table
            *ngIf="reservationSpecialDateTypeControl.value===RESERVATION_SPECIAL_DATE_TYPE_SPECIAL && reservationUnit===RESERVATION_UNIT_TIME">
            <thead>
              <tr>
                <th width="60px">{{'開始日' | translate}}</th>
                <th width="20px"></th>
                <th width="60px"></th>
                <th width="20px"></th>
                <th width="60px">{{'終了日' | translate}}</th>
                <th width="20px"></th>
                <th width="60px"></th>
                <th></th>
                <th width="200px">{{'最大予約数' | translate}}</th>
                <th width="70px">{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropSelectItem($event)">
              <tr
                *ngFor="let reservation_select_time of reservationFacilitySpecial!.reservation_select_times!; let i = index"
                cdkDrag cdkDragLockAxis="y">
                <td width="60px">
                  <mat-select value="{{ reservation_select_time.items[0] }}">
                    <mat-option *ngFor="let start_hour of hours" value="{{ start_hour }}"
                      (click)="onSelectItemChange(i, 0, start_hour)">{{ start_hour }}</mat-option>
                  </mat-select>
                </td>
                <td width="20px">:</td>
                <td width="60px">
                  <mat-select value="{{ reservation_select_time.items[1] }}">
                    <mat-option *ngFor="let start_minute of minutes" value="{{ start_minute }}"
                      (click)="onSelectItemChange(i, 1, start_minute)">{{ start_minute }}</mat-option>
                  </mat-select>
                </td>
                <td width="20px">　〜　</td>
                <td width="60px">
                  <mat-select value="{{ reservation_select_time.items[2] }}">
                    <mat-option *ngFor="let end_hour of hours" value="{{ end_hour }}"
                      (click)="onSelectItemChange(i, 2, end_hour)">{{ end_hour }}</mat-option>
                  </mat-select>
                </td>
                <td width="20px">:</td>
                <td width="60px">
                  <mat-select value="{{ reservation_select_time.items[3] }}">
                    <mat-option *ngFor="let end_minute of minutes" value="{{ end_minute }}"
                      (click)="onSelectItemChange(i, 3, end_minute)">{{ end_minute }}</mat-option>
                  </mat-select>
                </td>
                <td></td>
                <td width="200px">
                  <mat-form-field fxFlexFill floatLabel="always">
                    <input matInput value="{{ reservation_select_time.value }}"
                      (change)="onSelectValueChange($event, i)" type="number" required>
                  </mat-form-field>
                </td>
                <td width="70px" style="overflow: auto;">
                  <button mat-stroked-button color="warn" (click)="deleteClick(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <mat-form-field fxFlex="50%" *ngIf="reservationSpecialDateTypeControl.value===RESERVATION_SPECIAL_DATE_TYPE_SPECIAL && reservationUnit!==RESERVATION_UNIT_TIME">
            <mat-label floatLabel="always">{{'最大予約数' | translate}}</mat-label>
            <input matInput placeholder="{{'最大予約数' | translate}}" id="reservationSpecialCount" formControlName="reservationSpecialCount" type="number">
            <mat-error >{{ getErrorMessageToReservationSpecialCount() }}</mat-error>
          </mat-form-field>
        </div>
      </div>

    </form>
  </div>

</div>